import React from "react";
// mui
import { Card, Typography, Grid, Box, Skeleton } from "@mui/material";
import { useGetIdentity } from "react-admin";

export const GameDetails = ({ summaryData }) => {
  const UserMultipleIcon = "/Assets/Icons/user-multiple.svg";
  const { data: userIdentity } = useGetIdentity();
  const isSuperUser = userIdentity?.userRoleName === "Super-User";

  const rawData = [
    {
      id: 1,
      name: "Game Name",
      value: summaryData?.gameName ?? "-",
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
  ];

  // Only Super-User sees Game Variant
  if (isSuperUser) {
    rawData.push({
      id: 2,
      name: "Game Variant",
      value: summaryData?.gameType ?? "-",
      icon: UserMultipleIcon,
      color: "#18DC8B",
    });
  }

  return (
    <React.Fragment>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {summaryData === null ? (
          <>
            {[...Array(2)].map((_, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    backgroundColor: "#242424",
                    padding: 2,
                  }}
                >
                  <Skeleton
                    width="60%"
                    height={20}
                    sx={{
                      mt: 1,
                      background: "#fff",
                    }}
                  />
                  <Skeleton
                    width="40%"
                    height={30}
                    sx={{
                      mt: 1,
                      background: "#fff",
                    }}
                  />
                </Card>
              </Grid>
            ))}
          </>
        ) : (
          rawData?.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item?.id}>
              <Card
                sx={{
                  backgroundColor: "#242424",
                  color: "white",
                  padding: 2,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "1px solid rgba(255, 224, 51, 0.20)",
                }}
              >
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ color: "#999", fontWeight: 400, fontSize: 14 }}
                  >
                    {item?.name}
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ color: "#fff", fontWeight: 400, mt: 1, fontSize: 24 }}
                  >
                    {item?.value}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "rgba(255, 215, 0, 0.20)",
                    padding: 1,
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={item?.icon}
                    alt={item?.name}
                    style={{ width: 24, height: 24 }}
                  />
                </Box>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </React.Fragment>
  );
};
